interface Config {
    firebaseConfig: any,
    appDomain: string,
    nomeApp: string,
    versao: string
}

export const config: Config = {firebaseConfig:{apiKey:"AIzaSyDlVEvSVHInWrh7klECq49wKbjKEeFolBs",authDomain:"sindprevssc3-1f98b.firebaseapp.com",databaseURL:"https://sindprevssc3-1f98b.firebaseio.com",projectId:"sindprevssc3-1f98b",storageBucket:"sindprevssc3-1f98b.appspot.com",messagingSenderId:"390058966203",appId:"1:390058966203:web:1be3367f5103b963"},appDomain:"sindprevssc3",nomeApp:"SINDPREVSSC",versao:"2.3.2"}

Object.freeze(config);



// WEBPACK FOOTER //
// ./src/shared/config.ts